<template>
  <v-dialog
    v-model="dialog"
    max-width="290"
    @click:outside='cancel'
  >
    <v-card>
      <v-card-text>{{title}}</v-card-text>
      <v-card-subtitle>
        {{showText}}
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          text
          @click="cancel"
        >
          {{$t('label.no')}}
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading='loading'
          @click="confirm"
        >
          {{$t('label.yes')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {
      title: {
        type: String,
        default: '提示'
      },
      isOpen:{
          type: Boolean,
          required: true
      },
      isLoading:{
          type: Boolean,
          required: true
      },
      showText: {
        type: String,
        required: true
      }
  },
  data() {
    return {
        loading: false,
        dialog: false
    };
  },
  created() {},
  mounted() {
      this.loading = this.isLoading
      this.dialog = this.isOpen
  },
  methods: {
      confirm() {
        this.$emit('onConfirm')
      },
      cancel() {
          this.$emit('onCancel')
      }
  },
  computed: {},
  watch: {
      isLoading(val) {
          this.loading = val
      },
      isOpen(val) {
          this.dialog = val
      }
  },
};
</script>

<style scoped>
</style>
